<template>
  <div class="footer-media-edit">
    <menu-title :close="close">媒体配置</menu-title>
    <menu-item class="!pt-0" label="标题">
      <base-input v-model="target.title" />
    </menu-item>
    <div v-for="(item, index) in target.navs" :key="index" class="media-item">
      <div class="flex justify-between items-center text-13 mb-3">
        <span class="media-title">媒体 {{ index + 1 }}</span>
        <div class="delete-btn flex items-center justify-center" @click="handleRemove(index)">
          <i class="el-icon-delete" />
        </div>
      </div>
      <menu-item class="pt-0" label="图片">
        <menu-background-image :target="item.logo" />
      </menu-item>
      <menu-item class="pt-2" label="链接">
        <base-input v-model="item.url" />
      </menu-item>
    </div>
    <menu-button v-if="target.navs?.length < maxLength" class="mt-4" icon="add" @click.native.stop="handleAdd">添加媒体项</menu-button>
    <remove-btn class="mt-4" :click-fun="deleteBlock" />
  </div>
</template>

<script>
import FooterMixin from "~/site/widgets/footerWidget/mixinEdit";
import MenuButton from "~/components/menu/menuButton.vue";
import RemoveBtn from "~/components/common/RemoveBtn.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";

export default {
  name: 'FooterMediaEdit',
  components: {MenuBackgroundImage, RemoveBtn, MenuButton},
  mixins: [FooterMixin],
  props: {
    target: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      maxLength: 10
    }
  },
  methods: {
    handleAdd() {
      this.target.__addItem()
    },
    handleRemove(index) {
      this.target.navs.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="less">
.media-item {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .media-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 0.5px;
  }

  .delete-btn {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    color: rgba(255, 255, 255, 0.4);

    &:hover {
      background: rgba(255, 77, 79, 0.1);
      color: #ff4d4f;
    }
  }
}
</style>
